module.exports = __webpack_public_path__ + "media/images/badge/tiratore-scelto-419711272a21013fb71a80c25e8fbcde.png";